/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_RepliesInputs */

const en_platform_digest_replies = /** @type {(inputs: Platform_Digest_RepliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client replies`)
};

const pl_platform_digest_replies = /** @type {(inputs: Platform_Digest_RepliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzi podopiecznych`)
};

/**
* | output |
* | --- |
* | "Client replies" |
*
* @param {Platform_Digest_RepliesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_replies = /** @type {((inputs?: Platform_Digest_RepliesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_RepliesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_replies(inputs)
	return en_platform_digest_replies(inputs)
});